var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgParseJsonToList = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#31C4C0",
    d: "M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBFAF9",
    d: "M15 7.2a.45.45 0 0 0-.45-.45h-6.3a1.5 1.5 0 0 0-1.5 1.5v6.732a1.5 1.5 0 0 0 1.5 1.5h7.05q.021 0 .042-.002l-.607.607a.368.368 0 0 0 .521.52l1.25-1.25a.46.46 0 0 0 0-.65l-1.253-1.252a.368.368 0 0 0-.52.52l.608.609-.041-.002H8.25a.6.6 0 0 1-.6-.6V8.25a.6.6 0 0 1 .6-.6h6.3A.45.45 0 0 0 15 7.2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBFAF9",
    d: "M12.925 13.787q.08.08.2.08h.563a.54.54 0 0 0 .397-.165.54.54 0 0 0 .165-.397V9.93a.54.54 0 0 0-.165-.397.54.54 0 0 0-.398-.166h-.562a.27.27 0 0 0-.2.081.27.27 0 0 0-.081.2.276.276 0 0 0 .281.282h.563v3.375h-.563a.27.27 0 0 0-.2.08.27.27 0 0 0-.081.201q0 .12.08.2Zm-3.01-.085q.165.165.398.165h.562q.12 0 .2-.08a.27.27 0 0 0 .081-.2.27.27 0 0 0-.08-.201.27.27 0 0 0-.201-.081h-.563V9.93h.563q.12 0 .2-.08a.27.27 0 0 0 .081-.201.27.27 0 0 0-.08-.2.27.27 0 0 0-.201-.082h-.563a.54.54 0 0 0-.397.166.54.54 0 0 0-.165.397v3.375a.54.54 0 0 0 .165.397"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgParseJsonToList);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/parse-json-to-list.fb7c3009.svg";